export const isHandledError = (error: unknown): error is { statusCode: number } =>
  !!error &&
  typeof error === "object" &&
  "statusCode" in error &&
  typeof error.statusCode === "number"
